import './SkipLink.css';

/**
 * First focusable element on the page, visible only while focused (WCAG 2.4.1).
 *
 * Without it a keyboard or screen reader user tabs through the whole sidebar
 * on every route change before reaching the content they navigated to.
 *
 * Targets the `#main-content` landmark that each layout renders. That element
 * carries `tabIndex={-1}` so it can actually receive focus; without it the
 * browser scrolls but leaves focus behind on the link.
 */
export const SkipLink = () => (
  <a className="skip-link" href="#main-content">
    Skip to main content
  </a>
);
